import _ from 'lodash'
import resetStore from '../helpers/reset-store'
import axios from 'axios';

export const state = () => ({
  depots: [],
  departments: [],
  grades: [],
  costCentres: [],
  employees: [],
  allCostCentres: []
})

export const getters = {
  filters(state) {
    return state
  }
}

export const mutations = {
  reset: resetStore(state),
  setFilters(state, filters) {
    for (let key of Object.keys(filters)) {
      state[key] = filters[key]
    }
  }
}

export const actions = {
  async fetchFilters({ commit, rootGetters }, { getAllContact } = {}) {
    // Check for wp_contact_only setting internally
    const setting = rootGetters['account/setting']
    const currentUserId = rootGetters['account/currentUserId']
    const currentContactOnly = setting?.wp_contact_only || false
    
    const contactParams = {
      isInactive: getAllContact ? null : false,
      manpackUser: getAllContact ? null : true,
      $limit: 10000
    }

    // Add the internalId parameter if currentContactOnly is true - match old system exactly
    if (currentContactOnly && currentUserId) {
      contactParams.internalId = currentUserId
    }

    const [depots, departments, costCentres, employees] = await Promise.all([
      axios.get('/api/customer-address', {
        params: {
          $limit: 10000,
          'details.custrecord4.value[$ne]': true
        }
      }),
      axios.get('/api/department', {
        params: {
          isInactive: false
        }
      }),
      axios.get('/api/cost-centre'),
      axios.get('/api/contact', {
        params: contactParams
      })
    ])

    const grades = employees.data
      ? employees.data.data
          .filter(o => o.custentity_cbc_contact_grade)
          .map(employee => {
            return {
              value:
                employee.custentity_cbc_contact_grade.value.$attributes
                  .internalId,
              label: employee.custentity_cbc_contact_grade.value.name
            }
          })
      : []

    const filters = {
      depots: formatOptions(['label'], 'internalId', depots.data),
      departments: formatOptions(['name'], 'internalId', departments.data.data),
      grades: _.uniqBy(grades, o => o.value),
      costCentres: formatOptions(
        ['name'],
        'internalId',
        costCentres.data.data.filter(o => !o.isInactive)
      ),
      allCostCentres: formatOptions(
        ['name'],
        'internalId',
        costCentres.data.data
      ),
      employees: _.sortBy(formatEmployees(employees.data.data), o => o.fullName)
    }

    if (filters.grades.length) {
      filters.grades = _.sortBy(filters.grades, o => o.label)
    }

    if (filters.departments.length) {
      filters.departments = _.sortBy(filters.departments, o => o.label)
    }

    commit('setFilters', filters)
  }
}

function formatOptions(labelPaths, valuePath, options) {
  const data = options.map(option => {
    option.value = _.get(option, valuePath)
    option.label = labelPaths.map(path => _.get(option, path)).join(' ')
    return option
  })

  return data
}

function formatEmployees(employees) {
  return employees.map(employee => {
    employee.value = employee.internalId
    employee.fullName = [employee.firstName, employee.lastName].join(' ')
    let employeeNo = _.get(employee, 'custentity_bbs_emp_ref_no.value')
    employeeNo = employeeNo ? `(${employeeNo})` : ''
    employee.label = `${employee.fullName} ${employeeNo}`
    return employee
  })
}

export default {
  namespaced: true, // optional, if you want namespacing
  state,
  mutations,
  actions,
  getters,
};
